import { BasicLayout } from 'ui/components/BasicLayout';
import {
  BrokenLink,
  ButtonActor,
  FourOhFour,
  Heading,
  Shadow,
  Text,
} from 'internalLibrary';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import layout from '../../../scss/layout.module.scss';
import styles from './NotFound.module.scss';

const NotFoundScene: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const backToHomepageClicked = () => {
    navigate('/');
  };

  return (
    <BasicLayout>
      <div className={styles.main}>
        <div className={styles.graphics}>
          <BrokenLink
            style={{
              position: 'absolute',
              transform: 'translate(-70px, -70px)',
            }}
          />
          <FourOhFour />
          <Shadow
            style={{
              bottom: '0',
            }}
          />
        </div>

        <Heading
          text={t('notFound_title')}
          level="h1"
          weight="medium"
          className={styles.title}
        />

        <Text
          kind="span"
          level={2}
          text={t('notFound_subtitle')}
          className={styles.subtitle}
        />

        <ButtonActor
          buttonProps={{
            onClick: backToHomepageClicked,
            className: styles.button,
          }}
          className={classNames(styles.center, layout['width-md'])}
        >
          {t('notFound_buttonText')}
        </ButtonActor>
      </div>
    </BasicLayout>
  );
};

export default NotFoundScene;
